import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useEditorStore } from './stores/editorStore';
import { AppShell } from './components/layout/AppShell';
import { isRTL } from './i18n';

export default function App() {
  const { theme, language } = useEditorStore();
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  useEffect(() => {
    const rtl = isRTL(language);
    document.documentElement.setAttribute('dir', rtl ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', language);
    i18n.changeLanguage(language);
  }, [language, i18n]);

  return <AppShell />;
}
